import { AppConfig } from './../../app/app.config';
import { StorageService } from './../../providers/storage.service';
import { CommonService } from '../../services/common.service';
import { Component } from '@angular/core';
import { SigninService } from '../../services/signin.service';
import { AlertService } from '../../providers/alert.service';
import { SigninPage } from '../signin/signin';
import { NavController } from 'ionic-angular';
import { WechatPage } from './wechat';
import { WechatSettingModel } from '../../models/wechat.model';

@Component({
    selector: 'wechat',
    templateUrl: 'wechatbind.html',
    providers: [

    ]
})

export class WechatBindPage {
    message = "微信绑定执行中...";
    wechatSettings: WechatSettingModel;
    recode: string = "";
    state: string = "";
    constructor(
        private navCtrl: NavController,
        private signinService: SigninService,
        private alert: AlertService,
        private localStorage: StorageService,
        private common: CommonService,
        private appConfig: AppConfig
    ) {
        this.recode = "";
        this.wechatSettings = new WechatSettingModel();
    }

    ionViewDidLoad() {
        this.state = this.common.getParam("state");
        this.recode = this.common.getParam("code");
        this.wechatSettings = this.appConfig.GetWechatSettings();
        if (!this.wechatSettings) {
            this.wechatoAuth();
        } else {
            this.jumpWechatUrl();
        }
    }

    wechatoAuth() {
        this.common.oAuth().then((res: WechatSettingModel) => {
            if (res) {
                this.wechatSettings = res;
                this.localStorage.write("wechatsettings", this.wechatSettings);
            } else {
                this.navCtrl.push(SigninPage);
            }
        }).then(() => {
            this.jumpWechatUrl();
        }).catch((err) => {
            document.getElementById("errorMessage").innerHTML = err;
        })
    }


    jumpWechatUrl() {
        if (!this.state) {
            this.state = new Date().getTime() + "";
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="
                + this.wechatSettings.WxAppID + "&redirect_uri="
                + this.wechatSettings.WapJumpUrl + "&response_type=code&scope=snsapi_userinfo&state="
                + this.state + "#wechat_redirect";
        } else {
            this.wxBind(this.recode, this.state);
        }
    }

    wxBind(code, state) {
        state = this.localStorage.readString("wxbinding");
        let that = this;
        this.signinService.getwxbinding(code, state).then(s => {
            this.message = "微信账号绑定成功！";
            let t = setTimeout(() => {
                that.navCtrl.push(WechatPage);
                clearTimeout(t);
            }, 1000);
        }).catch(err => {
            this.message = JSON.parse(err._body).ExceptionMessage;
            let t = setTimeout(() => {
                that.navCtrl.push(SigninPage);
                clearTimeout(t);
            }, 2000);
        })
        this.localStorage.remove("wxbinding");
    }
}



// WEBPACK FOOTER //
// ./src/pages/wechat/wechatbind.ts